import {
    MtDriveFileTag,
    MtDriveVersionTag,
    SaveMtDriveFileTagType,
    SaveMtDriveVersionTagType,
} from "server/models"
import { POST } from "client/store/utils"


export const SaveDriveFileTags = (
    fileId: number,
    tags: MtDriveFileTag[],
) => {
    const tagData: SaveMtDriveFileTagType = {
        fileId,
        tags,
    }
    return POST(
        "/mtDriveFileTag/save",
        JSON.stringify(tagData),
    )
}

export const SaveDriveVersionTags = (
    versionId: number,
    tags: MtDriveVersionTag[],
) => {
    const tagData: SaveMtDriveVersionTagType = {
        versionId,
        tags,
    }
    return POST(
        "/mtDriveVersionTag/save",
        JSON.stringify(tagData),
    )
}
